<template>
    <div>
        <div id="imageModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="confirmModalLabel"
             aria-hidden="true">
            <div class="modal-dialog" :class="unsplashImages.length > 0 ? 'modal-xl' : ''" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="confirmModalLabel">Select Image</h5>
                        <button type="button" class="btn-close" @click="noHandler" aria-label="Close">

                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="d-flex my-1">
                            <label class="mt-1 mx-1" style="width: 120px;">Browse</label>
                            <div class="mx-1">
                                <div class="mb-3 pointer">
                                    <input class="form-control" type="file" id="fileElem" multiple @change="handleFileSelect">
                                </div>
                            </div>
                        </div>

                        <div class="d-flex my-1">
                            <label class="mt-1 mx-1" for="imageSearchInput" style="width: 120px;">Image Search</label>

                            <input type="text" class="mx-1 form-control" id="imageSearchInput" v-model="imageSearch" style="width: auto !important;"
                                   placeholder="search" v-on:keyup.enter="onSearchClick">

                            <button class="btn btn-primary mx-2" @click="onSearchClick" style="width: 137px;">search</button>

                            <button v-if="unsplashImages.length > 0" class="btn btn-primary mx-2" @click="onMoreClick" style="width: 137px;">next</button>
                        </div>

                        <div v-if="unsplashImages.length > 0" class="w-100 mt-2 d-flex justify-content-center flex-wrap">
                            <div v-for="unsplashImage in unsplashImages" class="mt-1 mx-2 pointer"
                                 @click="onImageSelected(unsplashImage)"
                                 :class="unsplashImage === selectedUnspashImage ? 'border-selected-image border-secondary' : ''">
                                <img :src="getImageUrl(unsplashImage)" width="300">
                                <div class="text-center" style="width: 300px;">
                                    <span class="badge text-bg-light">
                                        photo by <a :href="getAuthorLink(unsplashImage)" class="text-primary"
                                                    target="_blank">{{getImageAuthor(unsplashImage)}}</a> on <a
                                            href="https://unsplash.com/?utm_source=Webase&utm_medium=referral"
                                            class="text-primary" target="_blank">Unsplash</a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="yesHandler">Ok</button>
                        <button type="button" class="btn btn-secondary " @click="noHandler">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import UIUtil from "../../utils/UIUtil";
    import ImageService from "../../services/ImageService";
    import RestService from "../../services/RestService";

    export default {
        name: 'ImageModal',
        props: {
            yesEvent: Function,
            page: Object,
            view: Object,
            website: Object
        },
        computed: {
            selectFileLabel() {
                return this.selectedFile ? this.selectedFile.name : 'browse'
            }
        },
        data() {
            return {
                model: webase.model,
                uiUtil: new UIUtil(),
                highlightEnabled: false,
                imageSearch: '',
                unsplashImages: [],
                imageService: new ImageService(),
                selectedFile: null,
                selectedUnspashImage: null,
                currentPage: 1,
                currentModal: null,
                modalElement: null,
            }
        },
        mounted() {
            // add an event to trigger the parent's "noEvent" once the modal has been hidden
            // $('#imageModal').on('hidden.bs.modal', () => {
            //     this.$emit('noEvent')
            // })
            // // show the modal
            // $('#imageModal').modal('show')
            this.modalElement = document.getElementById('imageModal')
            this.currentModal = new bootstrap.Modal(this.modalElement)

            this.modalElement.addEventListener('hidden.bs.modal', this.onModalHidden)

            this.currentModal.show()

        },
        beforeUnmount() {
            this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden)
        },
        methods: {
            onModalHidden() {
                this.$emit('noEvent')
            },
            onMoreClick() {
                this.currentPage++
                this.onSearchClick()
            },
            onSearchClick() {

                let service = new RestService()
                let url = webase.utils.app.getBaseUrl() + '/api/v1/unsplash-search/?query=' + this.imageSearch + '&page=' + this.currentPage + '&t=' + Date.now()
                service.executeGet(url).then( (json) => {
                    this.unsplashImages = json.results

                    let properties = {
                        searchString: this.imageSearch,
                        total: json.total,
                        total_pages: json.total_pages
                    }

                    console.log('Image search')
                    console.log(properties)

                    webase.events.track('UnsplashSearch', properties);
                }).catch( (error) => {
                    console.log('UnsplashSearch error')
                    console.log(error)
                })

            },
            noHandler(e) {
                // hide the modal
                // $('#imageModal').modal('hide')
                this.currentModal.hide()
            },
            yesHandler(e) {

                if (this.selectedFile) {
                    this.uploadFile()
                    return
                }

                if (this.selectedUnspashImage) {
                    this.saveUnsplashImage()
                    return
                }

            },
            onFinished(image) {
                if (this.yesEvent) {
                    this.yesEvent(image)
                }

                this.noHandler()
            },
            handleFileSelect(event) {
                let files = event.target.files

                if (files && files[0]) {
                    this.selectedFile = files[0]
                }
            },
            saveUnsplashImage() {
                this.model.loading = true

                let request = {
                    image: {
                        name: this.imageSearch,
                        source: 'Unsplash',
                        imageable_type: this.getImageableType(),
                        imageable_id: this.getImageableId(),
                        metadata: this.selectedUnspashImage
                    }
                }

                this.imageService.create(request).then((image) => {
                    this.model.loading = false
                    this.onFinished(image)
                    this.triggerDownload()
                }).catch((error) => {
                    console.log('Unsplash image save error')
                    console.log(error)
                    this.model.loading = false
                    this.noHandler()
                    alert('Image upload error, ' + error)
                })
            },
            uploadFile() {
                this.model.loading = true
                let imageableType = this.getImageableType()
                let imageableId = this.getImageableId()

                this.imageService.uploadImage(imageableType, imageableId, this.selectedFile).then((image) => {
                    this.model.loading = false
                    this.onFinished(image)

                }).catch((error) => {
                    console.log('Image upload error')
                    console.log(error)
                    this.model.loading = false
                    this.noHandler()
                    alert('Image upload error, ' + error)
                })
            },
            getImageableType() {
                if(this.page && this.page.id) {
                    return 'Page'
                }

                if(this.view) {
                    return 'View'
                }

                return 'Website'
            },
            getImageableId() {
                if(this.page && this.page.id) {
                    return this.page.id
                }

                if(this.view) {
                    return this.view.id
                }

                return this.website.id
            },
            getImageUrl(image) {
                return image.urls.small
            },
            getImageAuthor(image) {
                return image.user.name
            },
            getAuthorLink(image) {
                return image.user.links.html + '?utm_source=Webase&utm_medium=referral'
            },
            onImageSelected(unsplashImage) {
                this.selectedUnspashImage = unsplashImage
            },
            triggerDownload() {
                let service = new RestService()
                let url = webase.utils.app.getBaseUrl() + '/api/v1/unsplash-download/' + this.selectedUnspashImage.id + '?t=' + Date.now()
                service.executeGet(url)
            }
        }
    }
</script>
